module.exports = __webpack_public_path__ + "static/media/2d5f91cbc8faa21103d08ce9d19040d6.3f44ffa5.woff";